/**
 * Stats Block - Counter Animation Module.
 *
 * Animates numbers with easing when stats section enters the viewport.
 */

export const initStats = () => {
	const counters = document.querySelectorAll('.numeric-animation, .stat-counter');
	if (!counters.length) return;

	const animateCounter = (el) => {
		if (el.dataset.animated) return;
		el.dataset.animated = 'true';

		const targetStr = el.dataset.count || el.textContent;
		const target = parseFloat(targetStr.replace(/,/g, ''));
		if (isNaN(target)) return;

		const isDecimal = targetStr.includes('.');
		const decimalPlaces = isDecimal ? targetStr.split('.')[1].length : 0;
		const duration = 1800;
		const startTime = performance.now();

		const updateCount = (currentTime) => {
			const elapsed = currentTime - startTime;
			const progress = Math.min(elapsed / duration, 1);
			const easeOut = 1 - Math.pow(1 - progress, 3);
			const current = easeOut * target;

			el.textContent = isDecimal
				? current.toFixed(decimalPlaces)
				: Math.floor(current).toLocaleString();

			if (progress < 1) {
				requestAnimationFrame(updateCount);
			} else {
				el.textContent = isDecimal ? target.toFixed(decimalPlaces) : target.toLocaleString();
			}
		};

		requestAnimationFrame(updateCount);
	};

	if ('IntersectionObserver' in window) {
		const observer = new IntersectionObserver(
			(entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						animateCounter(entry.target);
						obs.unobserve(entry.target);
					}
				});
			},
			{ threshold: 0.15 }
		);

		counters.forEach((counter) => observer.observe(counter));
	} else {
		counters.forEach((counter) => animateCounter(counter));
	}
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initStats);
} else {
	initStats();
}

if (typeof window !== 'undefined' && window.acf) {
	window.acf.addAction('render_block_preview/type=stats', initStats);
}

export default initStats;